import type { FC } from "react";
import { MailIcon } from "lucide-react-native";

import { BackButton } from "@/blocks/BackButton";
import { InfoCard } from "@/blocks/InfoCard";
import { VnBox } from "@/components/VnBox";
import { VnIcon } from "@/components/VnIcon";
import { VnText } from "@/components/VnText/VnText";
import { I18nKeyType } from "@/i18n";

export type CheckYourEmailPropsType = {
  email: string;
  bodyI18nKey?: I18nKeyType;
  onBackPress?: () => void;
};

export const CheckYourEmail: FC<CheckYourEmailPropsType> = ({
  email,
  bodyI18nKey = "native:authScreen.weSentALink",
  onBackPress,
}) => {
  return (
    <VnBox>
      <VnBox className="items-start">
        <BackButton
          textClassName="text-sidebar"
          iconClassName="text-sidebar"
          onPress={onBackPress}
          variant="ghost"
        />
      </VnBox>
      <VnBox className="items-center gap-3">
        <VnBox className="bg-chart-four rounded-full p-4">
          <VnIcon as={MailIcon} size={32} className="text-sidebar" />
        </VnBox>
        <VnText
          variant="headerOne"
          i18nKey="native:authScreen.checkYourEmail"
          className="text-center"
        />
        <VnText
          variant="lg"
          i18nKey={bodyI18nKey}
          className="text-muted-foreground text-center"
          i18nOptions={{
            email,
          }}
        />
        <InfoCard
          titleI18nKey="native:authScreen.checkYourSpam"
          className="bg-sidebar/10 border-border mt-10 rounded-3xl"
          titleClassName="text-amber-900"
        />
      </VnBox>
    </VnBox>
  );
};
